export const MESSAGES_REQUEST = 'MESSAGES_REQUEST'

const initialState = {
  fetching: true,
}

export default function loadingMessages(state = initialState, action) {
  switch (action.type) {
    case MESSAGES_REQUEST: {
      const { fetching, fetchingUp } = action
      return Object.assign({}, state, { fetching, fetchingUp })
    }
    default: {
      return state
    }
  }
}
